import { render, staticRenderFns } from "./SubHeaderGeneral.vue?vue&type=template&id=083124e9&scoped=true&"
import script from "./SubHeaderGeneral.vue?vue&type=script&lang=js&"
export * from "./SubHeaderGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderGeneral.vue?vue&type=style&index=0&id=083124e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083124e9",
  null
  
)

export default component.exports